/**
 * Public runtime config, injected by the server into index.html as
 * `window.__APP_CONFIG__` (see apps/server/src/client-config.ts). Read config
 * from HERE — never from `import.meta.env` — so stage-specific values are not
 * baked into the bundle and one built artifact promotes across environments.
 *
 * In dev (Vite serves the SPA, no server injection) the global is absent and
 * every field falls back to a safe default. To add a new value: add it to the
 * server's `clientPublic` allowlist (env-spec.ts) and to this interface.
 */
export interface AppConfig {
  stage: string;
  release?: string;
  sentryDsn?: string;
}

declare global {
  interface Window {
    __APP_CONFIG__?: Partial<AppConfig>;
  }
}

const raw = (typeof window !== 'undefined' && window.__APP_CONFIG__) || {};

export const config: AppConfig = {
  stage: raw.stage ?? 'unknown',
  release: raw.release,
  sentryDsn: raw.sentryDsn,
};
